import React, { Fragment } from 'react'
import { Box, Typography } from '@mui/material'

const sx = {
  title: {
    color: theme => theme.palette.text.primary,
    fontSize: '1.4rem',
    marginTop: '1.5rem',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  wrapperDropdown: {
    position: 'relative',
    '& .dropdown-placeholder': {
      position: 'absolute',
      top: 0,
      right: 0,
      width: '100%',
      display: 'flex',
      justifyContent: 'end',
      borderRadius: 10,
      overflow: 'hidden',
      '& img': {
        width: '18%',
        marginTop: 1,
      },
    },
  },
}

function SalesOverviewPlaceholder() {
  return (
    <Fragment>
      <div className="mb-4 row px-3">
        <div className="col-4">
          <img
            className="w-100"
            src={process.env['REACT_APP_BRC_IMAGE_URL'] + '/svg/sales_popup_transactions.svg'}
            alt=""
          />
          <Typography variant="h2" sx={sx.title}>Transactions</Typography>
        </div>
        <div className="col-4">
          <img
            className="w-100"
            src={process.env['REACT_APP_BRC_IMAGE_URL'] + '/svg/sales_popup_volumes.svg'}
            alt=""
          />
          <Typography variant="h2" sx={sx.title}>Sales Volume</Typography>
        </div>

        <div className="col-4">
          <img
            className="w-100"
            src={process.env['REACT_APP_BRC_IMAGE_URL'] + '/svg/sales_popup_disputes.svg'}
            alt=""
          />
          <Typography variant="h2" sx={sx.title}>Disputes</Typography>
        </div>
      </div>

      <div className="row px-3">
        <div className="col-12">
          <Box sx={sx.wrapperDropdown}>
            <img
              className="w-100"
              src={process.env['REACT_APP_BRC_IMAGE_URL'] + '/svg/cashlow_popup_cashflow_invoices_table.svg'}
              alt=""
            />
            <div className="dropdown-placeholder">
              <img src={process.env['REACT_APP_BRC_IMAGE_URL'] + '/png/dropdown.png'} alt="" />
            </div>
          </Box>
        </div>
      </div>
    </Fragment>
  )
}

export default SalesOverviewPlaceholder
